<div>
  <p class="datum">{{ datum | date }}</p>
  <p class="titel">{{ titel }}</p>
  <div [innerHTML]="contentHtmlAsString"></div>
</div>
